// extracted by mini-css-extract-plugin
module.exports = {"free":"TagFree-module--free--fbS9A"};